



<div class="_dialog-title">
	<mat-icon svgIcon="logo" class="mr-2"></mat-icon>
	<span>{{ui.connectOptions.title | translate}}</span>
</div>

<div class="_dialog-content" >
	<div #alertDesc class="alert alert-info" [ngClass]="{'alert-info': !isInvalid, 'alert-danger': isInvalid}">{{ui.connectOptions.desc | translate}}</div>
	<div class="keypad-val-container">
		<div class="keypad-val brand-input-border" [class._hasVal]="ui.connectValue?.length">
			<!--<div class="_cap">{{'OAT.last4' | translate}}</div>-->
			<div class="_val" [class.text-danger]="ui.connectOptions.invalid">{{ui.connectValue}}</div>
		</div>
	</div>
	<app-inline-keypad #loginKeypad [data]="ui.connectOptions" (onChange)="onKeypadChange($event)"></app-inline-keypad>
</div>

<div class="_bottom-actions mt-4">
	<button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
	<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="apply()" [disabled]="!ui.connectValid" style="min-width: 120px">{{'continue' | translate}}</button>
</div>

